// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__NDmTh","empty":"ModalGraph_empty__1tXCn"};